import { walkTranslatableUnits } from './walk';
import {
  H5PParams,
  H5PSemantics,
  TranslatableField,
  WalkerOptions,
} from './types';

/**
 * Extract the ordered flat list of translatable units of a content.
 *
 * @param semantics The root library's semantics.json (top-level array).
 * @param params The content params (read-only — never mutated).
 * @param options `resolveSemantics` supplies semantics of embedded libraries;
 *   embeds whose semantics cannot be resolved are skipped gracefully.
 */
export const extractTranslatableFields = (
  semantics: H5PSemantics,
  params: H5PParams,
  options?: WalkerOptions,
): TranslatableField[] =>
  walkTranslatableUnits(semantics, params, options).fields;
